import { useRequest } from '@rahtab/auth/lib/token-based-auth';
import { ListScreen } from '@rahtab/stack-navigator';
import { withNumbers, withToman } from '@rahtab/system/lib/tools/string';
import {
  BottomSheet,
  Button,
  Card,
  CardCaption,
  CardContainer,
  Colors,
  getShadow,
  getSpacing,
  ImageButton,
  ListEmpty,
  Shape,
  Text,
  TextInput,
  TextView,
} from '@rahtab/ui';
import MerchandiseListEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/StoreMerchandises';
import { RouteProp } from '@react-navigation/native';
import { useLocation } from 'hooks/useLocation';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import useLinkBuilder from '../../hooks/useLinkBuilder';
import { RootStackType } from '../../Router';
import { useSubmitProduct } from './useSubmitProduct';

const Products: React.FC<ProductProps> = ({ route }) => {
  const [productBottomSheet, setProductBottomSheet] = useState(false);
  const [purchasedBottomSheet, setPurchasedBottomSheet] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<ItemInfo>();
  const { location } = useLocation();
  const [purchasedProducts, setPurchasedProducts] = useState<PurchasedProduct[]>([]);
  const [price, setPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState('0');
  const [amount, setAmount] = useState('');
  // const [unitPrice, setUnitPrice] = useState('');
  const [headerButton, setHeaderButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<ItemInfo[]>([]);
  const linkBuilder = useLinkBuilder<RootStackType>();
  const request = useRequest();
  const { customerName } = route.params;
  const { submitLoading, submitProduct, numOfProducts } = useSubmitProduct();
  const getActiveItemsAction = async (forSale: number) => {
    setLoading(true);
    try {
      const productData = await request<ItemInfo[]>('GetActiveItems', { params: `ForSale=${forSale}` });
      if (Array.isArray(productData)) {
        setLoading(false);
        setProducts(productData);
      } else {
        setLoading(false);
      }
    } catch (err) {}
  };
  useEffect(() => {
    getActiveItemsAction(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePress = (item: ItemInfo) => {
    setSelectedProduct(item);
    setProductBottomSheet(true);
  };
  const handleSubmit = () => {
    if (selectedProduct && customerName) {
      submitProduct(
        customerName,
        selectedProduct.imageUrl,
        selectedProduct.itemName,
        selectedProduct.itemCode,
        amount,
        selectedProduct.measure,
        price,
        location?.coords.latitude || 0,
        location?.coords.longitude || 0,
      );
    }
  };
  const handlePrice = () => {
    let total = 0;
    purchasedProducts.map((p) => (total += parseFloat(p.price!)));
    setTotalPrice(total.toString());
  };
  return (
    <>
      <BottomSheet visible={productBottomSheet} onRequestClose={() => setProductBottomSheet(false)}>
        <Text variant="title" color="primary">
          {selectedProduct?.itemName}
        </Text>
        <Text color="description">
          تاریخ و نوع عرضه:{' '}
          <Text variant="cardTitle">
            {selectedProduct?.stockDate} | {selectedProduct?.distribution} {selectedProduct?.packInfo}
          </Text>
        </Text>
        <Text color="description">
          موجودی فعلی: <Text variant="cardTitle">{`${selectedProduct?.existent} ${selectedProduct?.measure}`}</Text>
        </Text>
        {/* <TextViewkosa
          borderColor="secondary"
          title="حداکثر مقدار قابل فروش"
          value={`${selectedProduct.stockAmount} ${selectedProduct.measure}`}
          isSpaceBetween
        /> */}
        <View style={styles.rowView}>
          <TextInput
            style={styles.inputText}
            placeholder="مقدار فروش را وارد نمایید."
            value={amount}
            keyboardType="numeric"
            onChangeText={withNumbers((v) => {
              setAmount(() => {
                if (selectedProduct?.price) setPrice((parseFloat(selectedProduct.price) * parseFloat(v)).toString());
                // else if (unitPrice && a) setPrice((parseFloat(unitPrice) * parseFloat(a)).toString());
                else setPrice('0');
                return v;
              });
            })}
          />
          <TextView
            value={selectedProduct?.measure}
            style={{ width: 80 }}
            textContainerStyle={{ justifyContent: 'center' }}
          />
        </View>
        <TextView title="قیمت واحد" value={withToman(selectedProduct?.price)} />
        <TextView title="قیمت کل" isSpaceBetween value={withToman(isNaN(parseFloat(price)) ? 0 : price)} />
        <Button
          text="ثبت کالا"
          color="primary"
          disabled={price === 'NaN'}
          onPress={() => {
            handleSubmit();
            setProductBottomSheet(false);
            setHeaderButton(true);
            setPurchasedProducts((product) => {
              product.push({
                itemName: selectedProduct?.itemName,
                amount: amount,
                price: price,
                measure: selectedProduct?.measure,
              });
              return product;
            });
            setAmount('0');
          }}
        />
      </BottomSheet>
      <BottomSheet visible={purchasedBottomSheet} onRequestClose={() => setPurchasedBottomSheet(false)}>
        <Card style={styles.card}>
          <CardCaption style={styles.topCardCaption}>
            <View style={styles.rowView}>
              <Text variant="cardTitle" margin="none">
                سبد خرید
              </Text>
            </View>
          </CardCaption>
          {purchasedProducts.map((p, i) => (
            <>
              <CardContainer key={i}>
                <Text color="description">
                  کالا: <Text variant="mediumBody">{p.itemName}</Text>
                </Text>
                <View style={styles.rowView}>
                  <Text color="description" margin="none">
                    مقدار:{' '}
                    <Text variant="mediumBody" margin="none">
                      {`${p.amount} ${p.measure}`}
                    </Text>
                  </Text>
                  <Text color="description" margin="none">
                    مبلغ:{' '}
                    <Text variant="mediumBody" margin="none">
                      {withToman(p.price)}
                    </Text>
                  </Text>
                </View>
              </CardContainer>
              <View
                style={StyleSheet.flatten([
                  styles.horizontalLine,
                  { display: i < purchasedProducts.length - 1 ? 'flex' : 'none' },
                ])}
              />
            </>
          ))}
          <CardCaption style={styles.bottomCardCaption} color="lightGray">
            <View style={styles.rowView}>
              <Text color="description" margin="none">
                جمع کل:
              </Text>
              <Text margin="none">{withToman(totalPrice)}</Text>
            </View>
          </CardCaption>
        </Card>
        <Button
          text="پایان عملیات فروش"
          color="primary"
          onPress={() => {
            setPurchasedBottomSheet(false);
          }}
          linkUrl={linkBuilder('Home')}
        />
      </BottomSheet>
      <ListScreen
        title={'محصولات فروشگاه'}
        loading={loading}
        transparentLoading={submitLoading}
        listData={products}
        renderControls={() => {
          return (
            <>
              {headerButton && !!numOfProducts && (
                <View style={styles.headerButton}>
                  <TextView
                    title="تعداد اقلام خرید"
                    style={{ flex: 1 }}
                    isSpaceBetween
                    value={numOfProducts.toString()}
                    marginBottom={0}
                  />
                  <Button
                    style={styles.button}
                    text="پایان عملیات فروش"
                    color="primary"
                    onPress={() => {
                      handlePrice();
                      setPurchasedBottomSheet(true);
                    }}
                  />
                </View>
              )}
            </>
          );
        }}
        ListEmptyComponent={
          <ListEmpty text="کالایی وجود ندارد." imageComponent={<MerchandiseListEmptyIcon width={200} height={200} />} />
        }
        numColumns={2}
        keyExtractor={(_, index) => index.toString()}
        renderItem={({ item, index }) => {
          return (
            <ImageButton
              captionColor="white"
              numberOfColumns={2}
              image={{ uri: item.imageUrl || '' }}
              name={item.itemName}
              onPress={() => handlePress(item)}>
              <Text color="secondary" style={styles.itemCode}>
                کد {item.templateCode}
              </Text>
            </ImageButton>
          );
        }}
      />
    </>
  );
};
export default Products;

const styles = StyleSheet.create({
  contentContainerStyle: {
    padding: getSpacing(0.5),
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.white,
    padding: getSpacing(),
  },
  button: { flex: 2, marginLeft: getSpacing(0.5) },
  inputText: { flex: 1, marginRight: getSpacing(0.5) },
  card: {
    marginBottom: getSpacing(),
    borderColor: Colors.darkGray,
    ...getShadow({ elevation: 0, opacity: 0, offsetHeight: 0, offsetWidth: 0, radius: 0 }),
  },
  topCardCaption: {
    paddingVertical: getSpacing(1.5),
    borderBottomColor: Colors.darkGray,
    borderBottomWidth: 0.75,
  },
  bottomCardCaption: {
    paddingVertical: getSpacing(1.5),
    borderTopColor: Colors.darkGray,
    borderTopWidth: 0.75,
  },
  horizontalLine: {
    borderBottomWidth: Shape.borderWidth,
    borderBottomColor: Colors.midGray,
    marginHorizontal: getSpacing(1.5),
  },
  itemCode: {
    textAlign: 'center',
  },
});

interface PurchasedProduct {
  itemName?: string;
  amount?: string;
  price?: string;
  measure?: string;
}
interface ItemInfo {
  itemCode: string;
  templateCode: string;
  itemName: string;
  price: string;
  distribution: string;
  packInfo: string;
  measure: string;
  imageUrl: string;
  existent: string;
  stockAmount: string;
  stockDate: string;
  quota: string;
}
interface ProductProps {
  route: RouteProp<RootStackType, 'Products'>;
}
